import { render } from "./PhotoView.vue?vue&type=template&id=a08f1584&scoped=true"
import script from "./PhotoView.vue?vue&type=script&lang=js"
export * from "./PhotoView.vue?vue&type=script&lang=js"

import "./PhotoView.vue?vue&type=style&index=0&id=a08f1584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08f1584"]])

export default __exports__